import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faSync } from "@fortawesome/free-solid-svg-icons";
import { useMicroserviceManagement } from "../hooks/MicroserviceManagerContext";

const ActionsDropdownToggle = React.forwardRef<HTMLDivElement>(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon={faEllipsis} />
    </div>
));

export type MicroserviceActionsDropdownProps = {
    children?: React.ReactNode | null
};

export const MicroserviceActionsDropdown = ({ children = null } : Readonly<MicroserviceActionsDropdownProps>) => {
    const menuId = React.useId();
    const { isSeedingAvailable, executeSeed } = useMicroserviceManagement();
    return (
        <div className="cursor-pointer">
            <Dropdown className="caret-off">
                <Dropdown.Toggle id={menuId} as={ActionsDropdownToggle} />
                <Dropdown.Menu style={{ maxWidth: '14rem' }}>
                    {isSeedingAvailable && (
                        <Dropdown.Item onClick={() => executeSeed()}>
                            <FontAwesomeIcon icon={faSync} size="sm" /> <span className="ms-1">Seed Microservice</span>
                        </Dropdown.Item>
                    )}
                    {children}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};